var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showModal
    ? _c(
        "modal",
        {
          staticClass: "selection-modal",
          on: {
            close: _vm.hideModalCancel,
            "hook:mounted": _vm.handleModalMounted,
          },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [_vm._v(_vm._s(_vm.modalTitle))]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "header-close-icon",
                on: { click: _vm.hideModalCancel },
              },
              [_c("i", { staticClass: "fal fa-times-circle" })]
            ),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c("div", { staticClass: "body-container" }, [
              _vm.sources && _vm.sources.length > 0
                ? _c(
                    "div",
                    { staticClass: "source-list-sidebar styleScroll" },
                    [
                      _c("div", { staticClass: "source-list-header" }, [
                        _vm._v("Sources"),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.sources, function (source) {
                        return _c(
                          "div",
                          {
                            key: source.id,
                            staticClass: "source-list-item",
                            on: {
                              mouseover: function ($event) {
                                return _vm.handleSourceMouseEnter(
                                  source.options
                                )
                              },
                              mouseleave: _vm.handleSourceMouseLeave,
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(source.name) +
                                "\n        "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "content-container" }, [
                _c("div", { staticClass: "content-header" }, [
                  _c("div", { staticClass: "select-all-checkbox" }, [
                    _c("label", { staticClass: "checkbox-label" }, [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: { checked: _vm.isSelectAllChecked },
                        on: { change: _vm.selectAllChangeHandler },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "checkbox-label" }, [
                        _vm._v("Select All"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        "search-field",
                        { "no-sidebar": !_vm.sources || !_vm.sources.length },
                      ],
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          placeholder: "Search by option title or description",
                          outlined: "",
                          dense: "",
                        },
                        on: { input: _vm.handleOptionSearchChange },
                        model: {
                          value: _vm.optionSearchInput,
                          callback: function ($$v) {
                            _vm.optionSearchInput = $$v
                          },
                          expression: "optionSearchInput",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "descriptions-toggle" }, [
                    _c(
                      "label",
                      {
                        staticClass: "legend-title legend-switch",
                        attrs: { tabindex: "0" },
                        on: {
                          keypress: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            _vm.showDescriptions = !_vm.showDescriptions
                          },
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.showDescriptions,
                              expression: "showDescriptions",
                            },
                          ],
                          attrs: {
                            id: "descriptionsToggleSwitch",
                            type: "checkbox",
                            checked: "",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.showDescriptions)
                              ? _vm._i(_vm.showDescriptions, null) > -1
                              : _vm.showDescriptions,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.showDescriptions,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.showDescriptions = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.showDescriptions = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.showDescriptions = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "legend-slider" }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "legend-title",
                        attrs: { for: "descriptionsToggleSwitch" },
                      },
                      [_vm._v("Show Descriptions")]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "content-body" }, [
                  _vm.categories && _vm.categories.length > 0
                    ? _c(
                        "div",
                        { staticClass: "option-checkbox-container" },
                        _vm._l(_vm.categories, function (category) {
                          return _c(
                            "div",
                            {
                              key: category.id,
                              staticClass: "option-category",
                            },
                            [
                              _c("label", { staticClass: "checkbox-label" }, [
                                _c("input", {
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: _vm.isCategorySelected(
                                      category.options
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.categoryCheckboxChangeHandler(
                                        $event,
                                        category.options
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "checkbox-label category-label",
                                  },
                                  [_vm._v(_vm._s(category.name))]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "option-category-list" },
                                _vm._l(
                                  _vm.getOptionsInCategory(category.id),
                                  function (option) {
                                    return _c(
                                      "div",
                                      {
                                        key: option.name,
                                        class: [
                                          {
                                            disabled: _vm.isOptionDisabled(
                                              option.name
                                            ),
                                          },
                                          "option-checkbox",
                                        ],
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "checkbox-label" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.selectedOptions,
                                                  expression: "selectedOptions",
                                                },
                                              ],
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                value: option.name,
                                                checked: Array.isArray(
                                                  _vm.selectedOptions
                                                )
                                                  ? _vm._i(
                                                      _vm.selectedOptions,
                                                      option.name
                                                    ) > -1
                                                  : _vm.selectedOptions,
                                              },
                                              on: {
                                                change: [
                                                  function ($event) {
                                                    var $$a =
                                                        _vm.selectedOptions,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = option.name,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.selectedOptions =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.selectedOptions =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.selectedOptions = $$c
                                                    }
                                                  },
                                                  _vm.optionSelectionChangeHandler,
                                                ],
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  bottom: "",
                                                  "open-delay": "500",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({ on }) {
                                                        return [
                                                          _c(
                                                            "span",
                                                            _vm._g(
                                                              {
                                                                staticClass:
                                                                  "checkbox-label",
                                                              },
                                                              on
                                                            ),
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  option.title
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(_vm._s(option.title)),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.showDescriptions,
                                                expression: "showDescriptions",
                                              },
                                            ],
                                            staticClass: "option-description",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                option.description ||
                                                  "no description specified"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.categories || !_vm.categories.length
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "option-checkbox-container no-categories",
                        },
                        _vm._l(_vm.options, function (option) {
                          return _c(
                            "div",
                            {
                              key: option.name,
                              class: [
                                { disabled: _vm.isOptionDisabled(option.name) },
                                "option-checkbox",
                              ],
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "checkbox-label" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedOptions,
                                        expression: "selectedOptions",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      value: option.name,
                                      checked: Array.isArray(
                                        _vm.selectedOptions
                                      )
                                        ? _vm._i(
                                            _vm.selectedOptions,
                                            option.name
                                          ) > -1
                                        : _vm.selectedOptions,
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$a = _vm.selectedOptions,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = option.name,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.selectedOptions =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.selectedOptions = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.selectedOptions = $$c
                                          }
                                        },
                                        _vm.optionSelectionChangeHandler,
                                      ],
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: {
                                        bottom: "",
                                        "open-delay": "500",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "span",
                                                  _vm._g(
                                                    {
                                                      staticClass:
                                                        "checkbox-label",
                                                    },
                                                    on
                                                  ),
                                                  [_vm._v(_vm._s(option.title))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(option.title)),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showDescriptions,
                                      expression: "showDescriptions",
                                    },
                                  ],
                                  staticClass: "option-description",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      option.description ||
                                        "no description specified"
                                    )
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "footer-container" }, [
                  _c("div", { staticClass: "reset-link-container" }, [
                    _c(
                      "div",
                      {
                        staticClass: "reset-link",
                        attrs: { tabindex: "0" },
                        on: {
                          click: _vm.resetSelection,
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.resetSelection.apply(null, arguments)
                          },
                          mouseover: function ($event) {
                            _vm.showResetTooltip = true
                          },
                          mouseleave: function ($event) {
                            _vm.showResetTooltip = false
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "reset-link-icon" }, [
                          _c("i", { staticClass: "fas fa-undo" }),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "reset-link-text" }, [
                          _vm._v("Reset to Defaults"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showResetTooltip,
                            expression: "showResetTooltip",
                          },
                        ],
                        staticClass: "reset-link-tooltip",
                      },
                      [
                        _vm._v("This will reset all options"),
                        _c("br"),
                        _vm._v("back to their default state"),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "button-container" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.selectedOptions.length === 0,
                            expression: "selectedOptions.length === 0",
                          },
                        ],
                        staticClass: "minimum-selection-text",
                      },
                      [
                        _vm._v(
                          "\n              Please select at least 1 option or attribute\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "cancel-button btn btn-default",
                        on: { click: _vm.hideModalCancel },
                      },
                      [_vm._v("Cancel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "ok-button btn btn-primary",
                        attrs: { disabled: _vm.selectedOptions.length === 0 },
                        on: { click: _vm.hideModalOK },
                      },
                      [_vm._v("OK")]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }